let overlayVideo;
let overlayVideoContainer;
let lastCurrentTime = 0;

// TODO: migrate into multiline text section input schema and parse to this format
const overlayData = [
    {handle: 'bao-bae-white', x: 65, y: 35, ti: 1.2, to: 3.2},
    {handle: 'bao-bae-black', x: 45, y: 55, ti: 5, to: 7.75},
    {handle: 'taro-tee-black', x: 15, y: 65, ti: 8, to: 10.3},
    {handle: 'order-me-milk-tee', x: 50, y: 65, ti: 8, to: 10.3},
    {handle: 'order-me-milk-tee', x: 70, y: 20, ti: 11, to: 12.5},
    {handle: 'order-me-taro-tee', x: 15, y: 35, ti: 15, to: 17.2},
    {handle: 'taro-tee-black', x: 70, y: 20, ti: 17.5, to: 18.5},
    {handle: 'milk-tee-black', x: 65, y: 35, ti: 19.5, to: 21},
    {handle: 'taro-tee-black', x: 35, y: 65, ti: 27.2, to: 29},
    {handle: 'milk-tee-white', x: 60, y: 65, ti: 27.2, to: 29},
    {handle: 'order-me-milk-tee', x: 35, y: 65, ti: 29, to: 31},
    {handle: 'order-me-taro-tee', x: 60, y: 65, ti: 29, to: 31},
];
let overlayElements = overlayData;


window.addEventListener('load', (event) => {
    overlayVideo = document.getElementById('overlay-video');
    overlayVideoContainer = document.getElementById('overlay-video-container');

    overlayVideo.addEventListener('timeupdate', (event) => {
        updateVideoOverlay();
    });
});


function updateVideoOverlay() {
    const currentTime = overlayVideo.currentTime;

    if (currentTime == 0 || currentTime < lastCurrentTime) {
        cleanupOverlayElements(
            Array.from(
                overlayVideoContainer.querySelectorAll("div.overlay-element-container")
            )
        );

        overlayElements = overlayData;
    }

    const elementsToAdd = overlayElements.filter(element => currentTime >= element.ti).map(element => { createOverlayElement(element) });
    overlayElements = overlayElements.filter(element => currentTime < element.ti);

    cleanupOverlayElements(
        Array.from(
            overlayVideoContainer.querySelectorAll("div.overlay-element-container")
        ).filter(
            element => currentTime >= element.getAttribute("timeOut")
        )
    );

    lastCurrentTime = currentTime;
}


function cleanupOverlayElements(elementsToRemove) {
    elementsToRemove.map(element => {
        if (element.hasAttribute("paused")) {
            overlayVideo.play();
        }

        element.remove();
    });
}


function createOverlayElement(overlayDataElement) {
    const product = productsMap.get(handleToIdMap.get(overlayDataElement.handle));

    const overlayDiv = document.createElement("div");
    overlayDiv.classList.add("overlay-element-container");
    overlayDiv.classList.add("text-body");
    overlayDiv.setAttribute("timeOut", overlayDataElement.to);

    overlayDiv.style.top = overlayDataElement.y.toString() + "%";
    overlayDiv.style.left = overlayDataElement.x.toString() + "%";

    overlayDiv.addEventListener('mouseenter', event => {
        overlayVideo.pause();
        overlayDiv.setAttribute("paused", "");
    })

    overlayDiv.addEventListener('mouseleave', event => {
        overlayVideo.play();
        overlayDiv.removeAttribute("paused");
    })

    const productNameNode = document.createTextNode(product.name);
    const productPriceNode = document.createTextNode(product.price);
    const breakNode = document.createElement("br");

    const aNode = document.createElement("a");
    aNode.classList.add("overlay-element-button");
    aNode.setAttribute("href", product.url);
    aNode.textContent = "Shop Now";

    overlayDiv.appendChild(productNameNode);
    overlayDiv.appendChild(breakNode);
    overlayDiv.appendChild(productPriceNode);
    overlayDiv.appendChild(breakNode.cloneNode());
    overlayDiv.appendChild(aNode);

    overlayVideoContainer.appendChild(overlayDiv);
}
